export default __webpack_public_path__ + "static/media/解析-logos_white.0cf5f326.png";